module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v(_vm._s(_vm.promoTitle))]), _vm._v(" "), _c('el-form', {
    ref: "form",
    attrs: {
      "label-width": "120px"
    }
  }, [_c('div', {
    staticClass: "interface-settings"
  }, [_c('h2', [_vm._v("Interface settings")]), _vm._v(" "), _c('div', {
    staticClass: "ui-row"
  }, [_c('span', [_vm._v("Square header image")]), _vm._v(" "), _c('el-switch', {
    model: {
      value: (_vm.squareHeader),
      callback: function($$v) {
        _vm.squareHeader = $$v
      },
      expression: "squareHeader"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ui-row"
  }, [_c('span', [_vm._v("Square lifestyle/product image")]), _vm._v(" "), _c('el-switch', {
    model: {
      value: (_vm.squareSecondary),
      callback: function($$v) {
        _vm.squareSecondary = $$v
      },
      expression: "squareSecondary"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ui-row"
  }, [_c('span', [_vm._v("No purchase options available")]), _vm._v(" "), _c('el-switch', {
    model: {
      value: (_vm.noPurchaseOptions),
      callback: function($$v) {
        _vm.noPurchaseOptions = $$v
      },
      expression: "noPurchaseOptions"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "container-add"
  }, [_c('div', {
    staticClass: "col-left"
  }, [_c('h2', [_vm._v("Models")]), _vm._v(" "), _vm._l((_vm.models), function(model, index) {
    return _c('el-card', {
      key: ("input-" + index),
      staticClass: "box-card"
    }, [_c('div', {
      staticClass: "header_item clearfix",
      attrs: {
        "slot": "header"
      },
      on: {
        "click": function($event) {
          _vm.toggleRowModels(index)
        }
      },
      slot: "header"
    }, [_c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(model.sku))]), _vm._v(" "), _c('el-button', {
      staticStyle: {
        "float": "right",
        "margin-top": "14px"
      },
      attrs: {
        "button": "",
        "type": "danger",
        "icon": "el-icon-delete",
        "circle": ""
      },
      on: {
        "click": function($event) {
          _vm.deleteRowModels(index)
        }
      }
    })], 1), _vm._v(" "), (model.show) ? _c('div', [_c('ul', [_c('li', [_c('el-form-item', {
      attrs: {
        "label": "SKU"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "SKU"
      },
      model: {
        value: (model.sku),
        callback: function($$v) {
          _vm.$set(model, "sku", $$v)
        },
        expression: "model.sku"
      }
    }, [_vm._v(_vm._s(model.sku))])], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Aan / Uit"
      }
    }, [_c('el-switch', {
      attrs: {
        "active-color": "#13ce66",
        "inactive-color": "#ff4949"
      },
      model: {
        value: (model.active),
        callback: function($$v) {
          _vm.$set(model, "active", $$v)
        },
        expression: "model.active"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "size": "large"
      }
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          _vm.toggleRowModels(index)
        }
      }
    }, [_vm._v("Opslaan")]), _vm._v(" "), _c('el-button', {
      on: {
        "click": function($event) {
          _vm.deleteRowModels(index)
        }
      }
    }, [_vm._v("Cancel")])], 1)], 1)])]) : _vm._e()])
  }), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    on: {
      "click": _vm.addRowModels
    }
  }, [_vm._v("Add new")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.openBulk
    }
  }, [_vm._v("Add Bulk")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "size": "large"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("Opslaan")]), _vm._v(" "), _c('el-button', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "col-right"
  }, [_c('h2', [_vm._v("Model list")]), _vm._v(" "), _vm._l((_vm.codes), function(input, index) {
    return _c('el-card', {
      key: ("input-" + index),
      staticClass: "box-card"
    }, [_c('div', {
      staticClass: "header_item clearfix",
      attrs: {
        "slot": "header"
      },
      on: {
        "click": function($event) {
          _vm.toggleRowCodes(index)
        }
      },
      slot: "header"
    }, [_c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(input.title))]), _vm._v(" "), _c('el-button', {
      staticStyle: {
        "float": "right",
        "margin-top": "14px"
      },
      attrs: {
        "button": "",
        "type": "danger",
        "icon": "el-icon-delete",
        "circle": ""
      },
      on: {
        "click": function($event) {
          _vm.deleteRowCodes(index)
        }
      }
    })], 1), _vm._v(" "), (input.show) ? _c('div', [_c('ul', [_c('li', [_c('el-form-item', {
      attrs: {
        "label": "Titel"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "Titel"
      },
      model: {
        value: (input.title),
        callback: function($$v) {
          _vm.$set(input, "title", $$v)
        },
        expression: "input.title"
      }
    }, [_vm._v(" - " + _vm._s(input.title))])], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Codes"
      }
    }, [_c('el-input', {
      attrs: {
        "type": "textarea",
        "placeholder": "codes..",
        "rows": "10"
      },
      model: {
        value: (input.text),
        callback: function($$v) {
          _vm.$set(input, "text", $$v)
        },
        expression: "input.text"
      }
    }, [_vm._v(" - " + _vm._s(input.text))])], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "size": "large"
      }
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          _vm.toggleRowCodes(index)
        }
      }
    }, [_vm._v("Opslaan")]), _vm._v(" "), _c('el-button', {
      on: {
        "click": function($event) {
          _vm.deleteRowCodes(index)
        }
      }
    }, [_vm._v("Cancel")])], 1)], 1)])]) : _vm._e()])
  }), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    on: {
      "click": _vm.addRowCodes
    }
  }, [_vm._v("Add new")])], 1)], 2)])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Bulk toevoegen",
      "visible": _vm.addBulk,
      "width": "50%",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.addBulk = $event
      }
    }
  }, [_c('el-form', [_c('p', [_vm._v("Add on every line a new model.")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Modelcodes"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 10
    },
    model: {
      value: (_vm.bulk),
      callback: function($$v) {
        _vm.bulk = $$v
      },
      expression: "bulk"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "size": "large"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addBulkModels
    }
  }, [_vm._v("Add")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ebbeb5e","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Add.vue
// module id = 221
// module chunks = 1